// import './assets/css/App.css';
// import '@fontsource/karla';
// import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import AuthLayout from './layouts/auth';
// import AdminLayout from './layouts/admin';
// import RTLLayout from './layouts/rtl';
// import {
//    ChakraProvider,
//    // extendTheme
// } from '@chakra-ui/react';
// import initialTheme from './theme/theme'; //  { themeGreen }
// import { AuthProvider } from './contexts/AuthContext';
// import { useNavigate } from 'react-router-dom';
// // Pages
// import SignInCentered from 'views/auth/signIn';
// import SignUpCentered from 'views/auth/signUp';
// import CreateCompany from 'views/auth/CreateComp';
// import { useSelector } from 'react-redux';
// import ToastContainerComponent from 'utils/ToastContainer';
// import { reportRoutes } from './routes'; // Import your routes
// import Profile from 'views/admin/profile';
// import CompProfile from 'views/admin/companyProfile';
// import PrintSetting from 'views/admin/settings/printSetting';
// import XmlSetting from 'views/admin/settings/xmlSetting';
// import GlobalSetting from 'views/admin/settings/GlobalSetting';
// import ManageUsers from 'components/navbar/ManageUsers/ManageUsers';
// import InvoiceFormatEditor from 'views/admin/settings/printSetting/InvoiceFormatEditor';
// import InvoiceFormatView from 'views/admin/settings/printSetting/InvoiceFormatView';
// import UnusedPurchaseInvoiceMaster from 'views/admin/utility/components/UnusedPurchaseInvoiceMaster';
// import QueryEditorPage from 'views/admin/settings/printSetting/QueryEditorPage';
// import ZeroNineAccounting from 'components/ZeronineWebsite/ZeronineHome';
// import RegistrationForm from 'views/auth/Registration/Registration';
// import TermsOfService from 'components/ZeronineWebsite/TermsOfService';
// import PrivacyPolicy from 'components/ZeronineWebsite/PrivacyPolicy';
// import RefundPolicy from 'components/ZeronineWebsite/RefundPolicy';
// import HelpSupport from 'components/ZeronineWebsite/HelpSupport';
// import AboutPage from 'components/ZeronineWebsite/ZeronineAbout';
// // import PrivateRoute from 'PrivateRoute';
// // Private route component
// // import PrivateRoute from './PrivateRoute';
// // import { Provider } from 'react-redux';
// // import { store } from './redux/store';
// // Chakra imports

// export default function Main() {
//    // eslint-disable-next-line
//    const [currentTheme, setCurrentTheme] = useState(initialTheme);
//    const navigate = useNavigate();
//    const location = useLocation();
//    const isAuthenticated = useSelector((state) => state.auth.login);
//    const [isShortcutMode, setIsShortcutMode] = useState(false);

//    // useEffect(() => {
//    //    const handleWindowClose = (e) => {
//    //       // Check if this is a page refresh (not perfect but helps)
//    //       const isRefresh = performance.navigation.type === performance.navigation.TYPE_RELOAD;

//    //       if (!isRefresh) {
//    //          localStorage.removeItem('authTokenCustomer');
//    //       }
//    //    };

//    //    // More reliable for browser close than beforeunload
//    //    window.addEventListener('pagehide', handleWindowClose);

//    //    return () => {
//    //       window.removeEventListener('pagehide', handleWindowClose);
//    //    };
//    // }, []);

//    // useEffect(() => {
//    //    if (!isAuthenticated) {
//    //       navigate('/auth/sign-in');
//    //    }
//    // }, [isAuthenticated, navigate]);
//    useEffect(() => {
//       if (!isAuthenticated) return;

//       const isInputField = () => {
//          const activeElement = document.activeElement;
//          const inputTags = ['INPUT', 'TEXTAREA', 'SELECT'];
//          return activeElement && (inputTags.includes(activeElement.tagName) || activeElement.isContentEditable);
//       };

//       const handleKeyDown = (event) => {
//          // Don't trigger shortcuts if Ctrl, Meta (Cmd), or Shift is pressed
//          if (event.ctrlKey || event.metaKey || event.shiftKey) return;

//          if (isInputField()) return;

//          // Press ALT to show shortcuts (toggle shortcut mode)
//          if (event.key === 'Alt') {
//             setIsShortcutMode((prev) => !prev);
//             event.preventDefault();
//             return;
//          }

//          // Only handle shortcut keys if shortcut mode is active
//          if (isShortcutMode) {
//             const key = event.key.toLowerCase();
//             const currentPath = location.pathname;
//             const isPrintSettingsPage = currentPath.startsWith('/admin/setting/print-settings/edit/');

//             switch (key) {
//                case 'd':
//                   navigate('/admin/default');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'm':
//                   navigate('/admin/masters/customers');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'r':
//                   navigate('/admin/report');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 's':
//                   navigate('/admin/sales/invoice');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'p':
//                   navigate('/admin/purchase/invoice');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'i':
//                   navigate('/admin/inventory/issue');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'c':
//                   if (!isPrintSettingsPage) {
//                      navigate('/admin/cash');
//                      setIsShortcutMode(false);
//                      event.preventDefault();
//                   }
//                   break;
//                case 'b':
//                   navigate('/admin/bank');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'j':
//                   navigate('/admin/journal-vouchers');
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                case 'escape':
//                   setIsShortcutMode(false);
//                   event.preventDefault();
//                   break;
//                default:
//                   break;
//             }
//          }
//       };

//       document.addEventListener('keydown', handleKeyDown);

//       return () => {
//          document.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [navigate, isAuthenticated, isShortcutMode, location.pathname]);
//    // Add this separate useEffect to reset shortcut mode on route change
//    useEffect(() => {
//       // Reset shortcut mode whenever route changes
//       setIsShortcutMode(false);
//    }, [location.pathname]);

//    useEffect(() => {
//       if (!isAuthenticated) return;
//       // Variables for tracking key sequences
//       let keySequence = '';
//       let keySequenceTimer = null;

//       // Function to reset the key sequence
//       const resetKeySequence = () => {
//          keySequence = '';
//       };

//       const isInputField = () => {
//          const activeElement = document.activeElement;
//          if (!activeElement) return false;

//          // Standard input elements
//          const inputTags = ['INPUT', 'TEXTAREA', 'SELECT'];
//          if (inputTags.includes(activeElement.tagName)) return true;

//          // Content editable elements
//          if (activeElement.isContentEditable) return true;

//          // Check for specific input types (like rich text editors)
//          if (activeElement.role === 'textbox') return true;

//          return false;
//       };

//       // Detect if user is on Mac
//       const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

//       // Main keyboard event handler
//       const handleKeyDown = (event) => {
//          if (!isAuthenticated) return;

//          if (!isInputField() && event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey) {
//             // Check if current route starts with '/admin/report'
//             if (window.location.pathname.startsWith('/admin/report')) {
//                switch (event.key.toLowerCase()) {
//                   case 's':
//                      navigate('/admin/report/SalesDetail');
//                      event.preventDefault();
//                      break;
//                   case 'p':
//                      navigate('/admin/report/PurchaseDetail');
//                      event.preventDefault();
//                      break;
//                   default:
//                      break;
//                }
//             }
//          }

//          // Handle double-key shortcuts (when no modifier keys are pressed)
//          if (!isInputField() && !event.altKey && !event.ctrlKey && !event.metaKey) {
//             // Save the current key
//             keySequence += event.key;

//             // Reset the sequence after a short delay
//             clearTimeout(keySequenceTimer);
//             keySequenceTimer = setTimeout(resetKeySequence, 500);

//             // Check for double-key shortcuts
//             if (keySequence === 'SS' || keySequence === 'ss') {
//                navigate('/admin/sales/invoice/add');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'PP' || keySequence === 'pp') {
//                navigate('/admin/purchase/invoice/add');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'JJ' || keySequence === 'jj') {
//                navigate('/admin/journal-vouchers');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'LL' || keySequence === 'll') {
//                navigate('/admin/masters/ledger');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'OS' || keySequence === 'os') {
//                navigate('/admin/report/Outstanding');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'CC' || keySequence === 'cc') {
//                navigate('/admin/cash');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'BB' || keySequence === 'bb') {
//                navigate('/admin/bank');
//                resetKeySequence();
//                event.preventDefault();
//             } else if (keySequence === 'II' || keySequence === 'ii') {
//                navigate('/admin/report/Stock');
//                resetKeySequence();
//                event.preventDefault();
//             }
//             return;
//          }

//          const isPrimaryModifier = isMac ? event.metaKey : event.ctrlKey;

//          if (!isInputField() && isPrimaryModifier && !event.altKey) {
//             if (window.location.pathname.startsWith('/admin/report')) {
//                switch (event.key.toLowerCase()) {
//                   case 'b':
//                      navigate('/admin/report/BalanceSheet');
//                      event.preventDefault(); // Prevent browser's default behavior
//                      break;
//                   case 'n':
//                      navigate('/admin/report/ProfitLoss');
//                      event.preventDefault(); // Prevent browser's default behavior
//                      break;
//                   default:
//                      break;
//                }
//             }
//          }
//       };

//       // Add a single event listener
//       document.addEventListener('keydown', handleKeyDown);

//       // Cleanup function
//       return () => {
//          document.removeEventListener('keydown', handleKeyDown);
//          clearTimeout(keySequenceTimer);
//       };
//    }, [navigate, isAuthenticated]);

//    useEffect(() => {
//       // Define public routes that don't require authentication
//       const publicRoutes = ['/', '/about', '/termsofservice', '/privacypolicy', '/refundpolicy', '/helpsupport'];

//       // Get current path
//       const currentPath = window.location.pathname;

//       // Check if current path is public or auth route
//       const isPublicRoute = publicRoutes.some((route) => currentPath.startsWith(route));
//       const isAuthRoute = currentPath.startsWith('/auth');

//       // Only redirect if not authenticated AND not on public/auth route
//       if (!isAuthenticated && !isPublicRoute && !isAuthRoute) {
//          navigate('/auth/sign-in');
//       }
//    }, [isAuthenticated, navigate]);

//    return (
//       // <Provider store={store}>
//       <ChakraProvider theme={currentTheme}>
//          <AuthProvider>
//             <ToastContainerComponent />
//             <Routes>
//                <Route path="/" element={<ZeroNineAccounting />} />
//                {/* Public Routes */}
//                <Route path="auth/*" element={<AuthLayout />}>
//                   <Route path="sign-in" element={<SignInCentered />} />
//                   <Route path="sign-up" element={<SignUpCentered />} />
//                   <Route path="create-comp" element={<CreateCompany />} />
//                   <Route path="registration" element={<RegistrationForm />} />
//                </Route>
//                {/* <Route path="home" element={<ZeroNineAccounting />} /> */}
//                <Route path="about" element={<AboutPage />} />
//                <Route path="termsofservice" element={<TermsOfService />} />
//                <Route path="privacypolicy" element={<PrivacyPolicy />} />
//                <Route path="refundpolicy" element={<RefundPolicy />} />
//                <Route path="helpsupport" element={<HelpSupport />} />

//                {/* Private Routes */}
//                {/* <Route element={<PrivateRoute />}>
//             <Route path="admin/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />} />
//             <Route path="rtl/*" element={<RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />} />
//           </Route> */}
//                <Route path="admin/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}>
//                   <Route path="setting/profile" element={<Profile />} />
//                   <Route path="setting/co-profile" element={<CompProfile />} />
//                   <Route path="setting/manageusers" element={<ManageUsers />} />
//                   <Route path="setting/xml-settings" element={<XmlSetting />} />
//                   <Route path="setting/global-settings" element={<GlobalSetting />} />
//                   <Route path="setting/print-settings" element={<PrintSetting />} />
//                   <Route path="setting/print-settings/edit/:id" element={<InvoiceFormatEditor />} />
//                   <Route path="setting/print-settings/copy/:id" element={<InvoiceFormatEditor />} />
//                   <Route path="setting/print-settings/view/:id" element={<InvoiceFormatView />} />
//                   <Route path="setting/print-settings/view-editor" element={<InvoiceFormatEditor />} />
//                   <Route path="utility/synced-unapproved-entry" element={<UnusedPurchaseInvoiceMaster />} />
//                   <Route path="setting/print-settings/query" element={<QueryEditorPage />} />
//                </Route>
//                {/* <Route
//             path="admin/*"
//             element={
//               <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
//             }
//           > */}
//                {/* <Route element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />} /> */}
//                {/* <Route path="rtl/*" element={<RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />} /> */}
//                {/* Master Routes  */}
//                {/* <Route path="masters/*" element={<div><Outlet/></div>} /> */}
//                {/* </Route> */}
//                {/* Dynamic Company Routes */}
//                {/* <Route path="/:companyId/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}> */}
//                {/* Add your dynamic routes here, for example: */}
//                {/* <Route path="contacts" element={<ContactsPage />} />
//             <Route path="sales" element={<SalesPage />} /> */}
//                {/* Add more dynamic routes as needed */}
//                {/* </Route> */}
//                <Route path="rtl/*" element={<RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />}>
//                   {/* <Route path="admin/*" element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />} /> */}
//                   {/* <Route path="rtl/*" element={<RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />} /> */}
//                </Route>
//                {reportRoutes?.map((reportRoutes, index) => (
//                   <Route key={index} path={reportRoutes.path} element={reportRoutes.component} />
//                ))}
//                {/* Default redirect */}
//                {/* <Route path="/" exact element={<Navigate to="/" replace />} /> */}
//                {/* <Route path="/" exact element={<Navigate to="/auth/sign-in" replace />} /> */}
//             </Routes>
//          </AuthProvider>
//       </ChakraProvider>
//       // </Provider>
//    );
// }

import './assets/css/App.css';
import '@fontsource/karla';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import {
   ChakraProvider,
   // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { AuthProvider } from './contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
// Pages
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/signUp';
import CreateCompany from 'views/auth/CreateComp';
import { useSelector } from 'react-redux';
import ToastContainerComponent from 'utils/ToastContainer';
import { reportRoutes } from './routes'; // Import your routes
import Profile from 'views/admin/profile';
import CompProfile from 'views/admin/companyProfile';
import PrintSetting from 'views/admin/settings/printSetting';
import XmlSetting from 'views/admin/settings/xmlSetting';
import GlobalSetting from 'views/admin/settings/GlobalSetting';
import ManageUsers from 'components/navbar/ManageUsers/ManageUsers';
import InvoiceFormatEditor from 'views/admin/settings/printSetting/InvoiceFormatEditor';
import InvoiceFormatView from 'views/admin/settings/printSetting/InvoiceFormatView';
import UnusedPurchaseInvoiceMaster from 'views/admin/utility/components/UnusedPurchaseInvoiceMaster';
import QueryEditorPage from 'views/admin/settings/printSetting/QueryEditorPage';
import ZeroNineAccounting from 'components/ZeronineWebsite/ZeronineHome';
import RegistrationForm from 'views/auth/Registration/Registration';
import TermsOfService from 'components/ZeronineWebsite/TermsOfService';
import PrivacyPolicy from 'components/ZeronineWebsite/PrivacyPolicy';
import RefundPolicy from 'components/ZeronineWebsite/RefundPolicy';
import HelpSupport from 'components/ZeronineWebsite/HelpSupport';
import AboutPage from 'components/ZeronineWebsite/ZeronineAbout';
// import InvoiceFormatEditor from 'views/admin/settings/invoicePrintSetting/InvoiceFormatEditor';

export default function Main() {
   const [currentTheme, setCurrentTheme] = useState(initialTheme);
   const navigate = useNavigate();
   const location = useLocation();
   const isAuthenticated = useSelector((state) => state.auth.login);
   const [isShortcutMode, setIsShortcutMode] = useState(false);

   // Check authentication on component mount and route changes
   useEffect(() => {
      const checkAuthToken = () => {
         const authToken = localStorage.getItem('authTokenCustomer');
         return !!authToken; // Returns true if token exists, false otherwise
      };

      // Define public routes that don't require authentication
      const publicRoutes = ['/', '/about', '/termsofservice', '/privacypolicy', '/refundpolicy', '/helpsupport'];
      const authRoutes = ['/auth/sign-in', '/auth/sign-up', '/auth/registration'];

      const currentPath = location.pathname;

      // Check if current route is public or auth route
      const isPublicRoute = publicRoutes.some((route) => currentPath === route || currentPath.startsWith(route));
      const isAuthRoute = authRoutes.some((route) => currentPath === route || currentPath.startsWith(route));

      // If user is not authenticated and trying to access protected route, redirect to sign-in
      if (!checkAuthToken() && !isPublicRoute && !isAuthRoute) {
         navigate('/auth/sign-in', { replace: true });
         return;
      }

      // If user is authenticated and trying to access auth routes, redirect to admin
      if (checkAuthToken() && isAuthRoute) {
         navigate('/admin/default', { replace: true });
         return;
      }
   }, [location.pathname, navigate]);

   // Enhanced authentication check for protected routes
   useEffect(() => {
      const authToken = localStorage.getItem('authTokenCustomer');

      // If no token found and user is on protected route, redirect immediately
      if (!authToken && location.pathname.startsWith('/admin')) {
         navigate('/auth/sign-in', { replace: true });
         return;
      }

      // If no token found and user is on rtl protected route, redirect immediately
      if (!authToken && location.pathname.startsWith('/rtl')) {
         navigate('/auth/sign-in', { replace: true });
         return;
      }
   }, [location.pathname, navigate]);

   // Your existing shortcut handlers...
   useEffect(() => {
      if (!isAuthenticated) return;

      const isInputField = () => {
         const activeElement = document.activeElement;
         const inputTags = ['INPUT', 'TEXTAREA', 'SELECT'];
         return activeElement && (inputTags.includes(activeElement.tagName) || activeElement.isContentEditable);
      };

      const handleKeyDown = (event) => {
         // Don't trigger shortcuts if Ctrl, Meta (Cmd), or Shift is pressed
         if (event.ctrlKey || event.metaKey || event.shiftKey) return;

         if (isInputField()) return;

         // Press ALT to show shortcuts (toggle shortcut mode)
         if (event.key === 'Alt') {
            setIsShortcutMode((prev) => !prev);
            event.preventDefault();
            return;
         }

         // Only handle shortcut keys if shortcut mode is active
         if (isShortcutMode) {
            const key = event.key.toLowerCase();
            const currentPath = location.pathname;
            const isPrintSettingsPage = currentPath.startsWith('/admin/setting/print-settings/edit/');

            switch (key) {
               case 'd':
                  navigate('/admin/default');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'm':
                  navigate('/admin/masters/customers');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'r':
                  navigate('/admin/report');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 's':
                  navigate('/admin/sales/invoice');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'p':
                  navigate('/admin/purchase/invoice');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'i':
                  navigate('/admin/inventory/issue');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'c':
                  if (!isPrintSettingsPage) {
                     navigate('/admin/cash');
                     setIsShortcutMode(false);
                     event.preventDefault();
                  }
                  break;
               case 'b':
                  navigate('/admin/bank');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'j':
                  navigate('/admin/journal-vouchers');
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               case 'escape':
                  setIsShortcutMode(false);
                  event.preventDefault();
                  break;
               default:
                  break;
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate, isAuthenticated, isShortcutMode, location.pathname]);

   // Add this separate useEffect to reset shortcut mode on route change
   useEffect(() => {
      // Reset shortcut mode whenever route changes
      setIsShortcutMode(false);
   }, [location.pathname]);

   useEffect(() => {
      if (!isAuthenticated) return;
      // Variables for tracking key sequences
      let keySequence = '';
      let keySequenceTimer = null;

      // Function to reset the key sequence
      const resetKeySequence = () => {
         keySequence = '';
      };

      const isInputField = () => {
         const activeElement = document.activeElement;
         if (!activeElement) return false;

         // Standard input elements
         const inputTags = ['INPUT', 'TEXTAREA', 'SELECT'];
         if (inputTags.includes(activeElement.tagName)) return true;

         // Content editable elements
         if (activeElement.isContentEditable) return true;

         // Check for specific input types (like rich text editors)
         if (activeElement.role === 'textbox') return true;

         return false;
      };

      // Detect if user is on Mac
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

      // Main keyboard event handler
      const handleKeyDown = (event) => {
         if (!isAuthenticated) return;

         if (!isInputField() && event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey) {
            // Check if current route starts with '/admin/report'
            if (window.location.pathname.startsWith('/admin/report')) {
               switch (event.key.toLowerCase()) {
                  case 's':
                     navigate('/admin/report/SalesDetail');
                     event.preventDefault();
                     break;
                  case 'p':
                     navigate('/admin/report/PurchaseDetail');
                     event.preventDefault();
                     break;
                  default:
                     break;
               }
            }
         }

         // Handle double-key shortcuts (when no modifier keys are pressed)
         if (!isInputField() && !event.altKey && !event.ctrlKey && !event.metaKey) {
            // Save the current key
            keySequence += event.key;

            // Reset the sequence after a short delay
            clearTimeout(keySequenceTimer);
            keySequenceTimer = setTimeout(resetKeySequence, 500);

            // Check for double-key shortcuts
            if (keySequence === 'SS' || keySequence === 'ss') {
               navigate('/admin/sales/invoice/add');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'PP' || keySequence === 'pp') {
               navigate('/admin/purchase/invoice/add');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'JJ' || keySequence === 'jj') {
               navigate('/admin/journal-vouchers');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'LL' || keySequence === 'll') {
               navigate('/admin/masters/ledger');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'OS' || keySequence === 'os') {
               navigate('/admin/report/Outstanding');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'CC' || keySequence === 'cc') {
               navigate('/admin/cash');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'BB' || keySequence === 'bb') {
               navigate('/admin/bank');
               resetKeySequence();
               event.preventDefault();
            } else if (keySequence === 'II' || keySequence === 'ii') {
               navigate('/admin/report/Stock');
               resetKeySequence();
               event.preventDefault();
            }
            return;
         }

         const isPrimaryModifier = isMac ? event.metaKey : event.ctrlKey;

         if (!isInputField() && isPrimaryModifier && !event.altKey) {
            if (window.location.pathname.startsWith('/admin/report')) {
               switch (event.key.toLowerCase()) {
                  case 'b':
                     navigate('/admin/report/BalanceSheet');
                     event.preventDefault(); // Prevent browser's default behavior
                     break;
                  case 'n':
                     navigate('/admin/report/ProfitLoss');
                     event.preventDefault(); // Prevent browser's default behavior
                     break;
                  default:
                     break;
               }
            }
         }
      };

      // Add a single event listener
      document.addEventListener('keydown', handleKeyDown);

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
         clearTimeout(keySequenceTimer);
      };
   }, [navigate, isAuthenticated]);

   return (
      <ChakraProvider theme={currentTheme}>
         <AuthProvider>
            <ToastContainerComponent />
            <Routes>
               {/* Public Routes - No authentication required */}
               <Route path="/" element={<ZeroNineAccounting />} />
               <Route path="about" element={<AboutPage />} />
               <Route path="termsofservice" element={<TermsOfService />} />
               <Route path="privacypolicy" element={<PrivacyPolicy />} />
               <Route path="refundpolicy" element={<RefundPolicy />} />
               <Route path="helpsupport" element={<HelpSupport />} />

               {/* Auth Routes - No authentication required */}
               <Route path="auth/*" element={<AuthLayout />}>
                  <Route path="sign-in" element={<SignInCentered />} />
                  <Route path="sign-up" element={<SignUpCentered />} />
                  <Route path="create-comp" element={<CreateCompany />} />
                  <Route path="registration" element={<RegistrationForm />} />
               </Route>

               {/* Protected Routes - Authentication required */}
               <Route
                  path="admin/*"
                  element={
                     localStorage.getItem('authTokenCustomer') ? (
                        <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
                     ) : (
                        <Navigate to="/auth/sign-in" replace />
                     )
                  }>
                  <Route path="setting/profile" element={<Profile />} />
                  <Route path="setting/co-profile" element={<CompProfile />} />
                  <Route path="setting/manageusers" element={<ManageUsers />} />
                  <Route path="setting/xml-settings" element={<XmlSetting />} />
                  <Route path="setting/global-settings" element={<GlobalSetting />} />
                  <Route path="setting/print-settings" element={<PrintSetting />} />
                  {/* <Route path="setting/print-settings/edit/:id" element={<InvoiceFormatEditor />} /> */}
                  <Route path="setting/print-settings/edit/:id" element={<InvoiceFormatEditor />} />
                  <Route path="setting/print-settings/copy/:id" element={<InvoiceFormatEditor />} />
                  <Route path="setting/print-settings/view/:id" element={<InvoiceFormatView />} />
                  <Route path="setting/print-settings/view-editor" element={<InvoiceFormatEditor />} />
                  <Route path="utility/synced-unapproved-entry" element={<UnusedPurchaseInvoiceMaster />} />
                  <Route path="setting/print-settings/query" element={<QueryEditorPage />} />
               </Route>

               {/* RTL Protected Route - Authentication required */}
               <Route
                  path="rtl/*"
                  element={
                     localStorage.getItem('authTokenCustomer') ? (
                        <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
                     ) : (
                        <Navigate to="/auth/sign-in" replace />
                     )
                  }
               />

               {/* Report Routes */}
               {reportRoutes?.map((reportRoutes, index) => (
                  <Route key={index} path={reportRoutes.path} element={reportRoutes.component} />
               ))}

               {/* Default redirect for unknown routes */}
               <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
         </AuthProvider>
      </ChakraProvider>
   );
}
